import { render, staticRenderFns } from "./CashierElement.vue?vue&type=template&id=2b578f16&scoped=true"
import script from "./CashierElement.vue?vue&type=script&lang=js"
export * from "./CashierElement.vue?vue&type=script&lang=js"
import style0 from "./CashierElement.vue?vue&type=style&index=0&id=2b578f16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b578f16",
  null
  
)

export default component.exports